<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>网站信息</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>网站信息维护</span>
      </div>
      <div class="text item">
        <!-- 操作对话框 -->
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :status-icon="true"
          @submit.native.prevent="submitForm('form')"
        >
          <el-form-item label="公司名称" prop="companyName">
            <el-input
              v-model.trim="form.companyName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="公司地址" prop="companyAddress">
            <el-input
              v-model.trim="form.companyAddress"
              placeholder="请输入公司地址"
            ></el-input>
          </el-form-item>

          <el-form-item label="公司网址" prop="webSite">
            <el-input
              v-model.trim="form.webSite"
              placeholder="请输入公司网址"
            ></el-input>
          </el-form-item>

          <el-form-item label="公司邮箱" prop="companyEmail">
            <el-input
              v-model.trim="form.companyEmail"
              placeholder="请输入公司邮箱"
            ></el-input>
          </el-form-item>

          <el-form-item label="公司传真" prop="companyFax">
            <el-input
              v-model.trim="form.companyFax"
              placeholder="请输入公司传真号码"
            ></el-input>
          </el-form-item>

          <el-form-item label="办公室电话" prop="officeTel">
            <el-input
              v-model.trim="form.officeTel"
              placeholder="请输入办公室电话号码"
            ></el-input>
          </el-form-item>

          <el-form-item label="销售部电话" prop="officePhone">
            <el-input
              v-model.trim="form.officePhone"
              placeholder="请输入销售部电话号码"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item
        label="办公室电话2"
        prop="officePhone2"
      >
        <el-input
          v-model.trim="form.officePhone2"
          placeholder="请输入办公室电话2"
        ></el-input>
      </el-form-item> -->

          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      loading: false,
      form: {}, //表单对象
      submiting: false,
    };
  },
  methods: {
    //获取网站信息
    getSiteInfo: function (row) {
      var link = url.getSiteInfo("GetSiteInfo");
      $.get(link, (res) => {
        this.form = res;
      });
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getSiteInfo("Save");
      var info = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    //获取服务器列表
    this.getSiteInfo();
  },
};
</script>

<style>
.el-card {
  margin-top: 30px;
}
</style>
